import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const portfolioSelector = ({ portfolio }: ReducerState) => portfolio;
export const portfolioLoadingSelector = createSelector(
  portfolioSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
